export const RED_COLOR = '#FF1F34';
export const BLUE_COLOR = '#0468FF';
export const POINT_RADIUS = 0;
export const POINT_HOVER_RADIUS = 4;
